// Quotation Rejected Stage  Btn related codes goes here

// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Button, Input, Tooltip } from "@revvsales/components";
import ReactHtmlParser from "react-html-parser";

import { GlobalUtils, DocumentUtils } from "../../../utils";
import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
// import ExportDocumentBtn from "../../QuotationTopbar/QuotationTopbarBtns/ExportDocumentBtn";
import PreviewDocument from "../../QuotationTopbar/QuotationTopbarBtns/PreviewDocument";
import REJECTED from "../../../assets/Badge-Rejected.png";
import DECLINED from "../../../assets/Declined.png";
import { fetchDocRecipientListAction } from "../../../actions/DocumentActions";
// import { USER_ROLES } from "../../../constants/roleList";

import QuickReviewIcon from "../../QuickReview/QuickReviewIcon";
import DocToTemplatePopup from "./DocToTemplate/DocToTemplatePopup";
import DocToTemplateBtn from "./DocToTemplate/DocToTemplateBtn";
import saveDocAsTemplate from "./DocToTemplate/methods";

// Service Imports
import { cloneDocumentService } from "../../../actions/DocumentActions/services";
import { QuotationActions } from "../../../actions";

// Image Imports
import SNAPLINK_PNG from "../../../assets/TT-Snaplink.png";
import MAGICLINK_PNG from "../../../assets/TT-Magic-Link.png";
import SEND_TO_SOMEONE_PNG from "../../../assets/TT-Send-to-somone.png";

// import SendForReview from "../../QuotationTopbar/QuotationTopbarBtns/SendForReview";
// Destructuring
const {
  copyToClipBoard,
  handleApiErrMsg,
  readDataFromLocalStorage,
} = GlobalUtils;
const { snaplinkGeneratedInfo } = DocumentUtils;
const { updateToolPaneData } = QuotationActions;

class QuotationRejectedBtns extends Component {
  state = {
    showMenu: false,
    showDocPreview: false,
    showRenamePopup: false,
    showReferralPopup: false,
    templateName: `${this.props.docName} Template`,
    showShareOptions: false,
    showMoreOptions: false,
  };

  componentDidMount() {
    this.props.fetchDocRecipientListAction(this.props.docID);
  }

  createExportRef = element => {
    this.exportRef = element;
  };

  createSendRef = element => {
    this.sendRef = element;
  };

  createShareRef = element => {
    this.shareRef = element;
  };

  componentWillMount = () => {
    document.addEventListener("mousedown", this.handleClick, false);
  };

  componentWillUnMount = () => {
    document.removeEventListener("mousedown", this.handleClick, false);
  };

  handleClick = e => {
    if (
      (this.exportRef && this.exportRef.contains(e.target)) ||
      (this.sendRef && this.sendRef.contains(e.target)) ||
      (this.shareRef && this.shareRef.contains(e.target))
    ) {
      return;
    }
    this.setState({
      showMenu: false,
      showShareOptions: false,
      showMoreOptions: false,
    });
    // this.props.updateToolPaneData(false, "");
  };

  showMenu = event => {
    event.preventDefault();
    const { showMenu } = this.state;
    if (!showMenu) {
      const objectId = this.props.docObjectId;
      const objectType = "DOC";
      this.props.getPermaLinkData(objectId, objectType);
      this.props.getSnapLinkData(objectId, objectType);
    }
    this.setState({
      showMenu: !showMenu,
      showShareOptions: false,
      showMoreOptions: false,
    });
  };

  showShareOptions = event => {
    event.preventDefault();
    const { showShareOptions } = this.state;
    if (!showShareOptions) {
      const objectId = this.props.docObjectId;
      const objectType = "DOC";
      this.props.getPermaLinkData(objectId, objectType);
      this.props.getSnapLinkData(objectId, objectType);
    }
    this.setState({
      showShareOptions: !showShareOptions,
      showMoreOptions: false,
      showMenu: false,
    });
  };

  showMoreOptions = event => {
    event.preventDefault();
    const { showMoreOptions } = this.state;
    this.setState({
      showMoreOptions: !showMoreOptions,
      showShareOptions: false,
      showMenu: false,
    });
  };

  _handleCopyLink = data => {
    if (copyToClipBoard(data)) {
      Toastr.showToastr({
        type: "success",
        message: "Copied Successfully",
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Error while copying!...",
        timeout: 3000,
      });
    }
  };

  _toggleDocPreviewPopUp = () => {
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    QuotationRejectedBtns.documentHTMLData =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    this.setState(prevState => ({
      showDocPreview: !prevState.showDocPreview,
      showMenu: false,
    }));
  };

  _handleOptionList = value => {
    if (value === "reviewer") {
      this.props.togglePopUp("showAddRecipientsPopup", true, "forReviewer");
      this.setState({ showMenu: false });
    } else if (value === "reffer") {
      this._toggleNavbarPopup("showReferralPopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "invite") {
      this.props.togglePopUp("showTeammatePopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "download") {
      this.props.togglePopUp("download", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "metalense") {
      this.setState({ showMoreOptions: false });
      this.props.updateToolPaneData(true, "quick-review");
    }
  };

  _acceptanceStatusBand = () => {
    const { acceptorsList, docRecipientList } = this.props;
    let bandStatus = null;
    const signerList = [];
    docRecipientList.map(item =>
      item.recipient_type === "SIGNER" ? signerList.push(item) : null,
    );
    if (acceptorsList && acceptorsList.length > 0) {
      bandStatus = (
        <div className="doc-declined-status-band">
          <img src={REJECTED} className="doc-imgband-check" alt="Revv" />
          <div>Document has been rejected by a receiver</div>
        </div>
      );
    } else if (signerList && signerList.length > 0) {
      bandStatus = (
        <div className="doc-declined-status-band">
          <img src={DECLINED} className="doc-imgband-check" alt="Revv" />

          <div>Document declined by a signer</div>
        </div>
      );
    }
    return bandStatus;
  };

  _cloneDocument = () => {
    cloneDocumentService(this.props.docID)
      .then(response => {
        const message = "Document successfully cloned";
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
        this.setState({
          showMenu: false,
        });
        const currentUrl = this.removeLastDirectoryPartOf(window.location.href);
        window.open(`${currentUrl}/${response.Document.doc_no}`);
      })
      .catch(error => {
        this.setState({
          showMenu: false,
        });
        const message = handleApiErrMsg(error);
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });
  };

  handleTemplateName = e => {
    this.setState({
      templateName: e.target.value,
    });
  };

  removeLastDirectoryPartOf = url => {
    const newUrl = url.split("/");
    newUrl.pop();
    return newUrl.join("/");
  };

  toggleDocToTemplatePopup = () => {
    this.setState(prevState => ({
      showRenamePopup: !prevState.showRenamePopup,
    }));
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  setStateToInitial = () => {
    this.setState({
      showRenamePopup: false,
      templateName: `${this.props.docName} Template`,
    });
  };

  onSave = () => {
    if (this.state.templateName) {
      saveDocAsTemplate(
        this.props.docID,
        this.state.templateName,
        this.setStateToInitial,
      );
    } else {
      const message = "Template name is required";
      Toastr.showToastr({
        type: "failure",
        message,
        timeout: 2000,
      });
    }
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let popupSpace = null;

    if (this.state.showRenamePopup && !this.props.isPdfDocument) {
      return (
        <DocToTemplatePopup
          togglePopup={this.toggleDocToTemplatePopup}
          handleTemplateName={this.handleTemplateName}
          templateName={this.state.templateName}
          saveDocAsTemplate={this.onSave}
        />
      );
    }
    if (this.state.showRenamePopup && this.props.isPdfDocument) {
      Toastr.showToastr({
        type: "warning",
        message: "Only .docx files can be saved as templates.",
        timeout: 3000,
      });
      this.setState({
        showRenamePopup: false,
      });
    }
    if (this.state.showReferralPopup) {
      popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    }

    return (
      <Fragment>
        {popupSpace}
        {/**
        {popupSpace}
        <Fragment>
          <div>
            <Tooltip placement="bottom" overlay="Refer and get benefits!">
              <span
                className="referral-wrapper"
                onClick={() =>
                  this._toggleNavbarPopup("showReferralPopup", true)
                }
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <span aria-label="referral-gift-wrapper" role="img">
                  🎁
                </span>
              </span>
            </Tooltip>
          </div>
          {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
            <div>
              <Tooltip placement="bottom" overlay="Invite team members to Revv">
                <span
                  className="user-role-wrapper"
                  onClick={() =>
                    this.props.togglePopUp("showTeammatePopup", true)
                  }
                  onKeyPress={() => {}}
                  tabIndex="0"
                  role="button">
                  <FontAwesomeIcon icon={["fas", "user-plus"]} />
                </span>
              </Tooltip>
            </div>
          )}
          <div className="user-invite-line" />
        </Fragment>
        {!this.props.showForm ? (
          <Tooltip
            placement="bottom"
            align={{
              offset: [0, 4],
            }}
            overlay="Cannot eSign documents that have been declined or rejected.">
            <div>
              <Button
                className="revv-btn-disabled-esign"
                id={"signerDetails".replace(/ +/g, "-").toLowerCase()}
                data-test="quotation-reject-btns-esign">
                <FontAwesomeIcon
                  icon={["far", "signature"]}
                  className="documentrecipientlist-role-icon"
                />
                &nbsp; eSign
              </Button>
            </div>
          </Tooltip>
        ) : null}
        */}
        <div>
          <div className="btn-export-wrapper" ref={this.createSendRef}>
            <Tooltip placement="bottom" overlay="Share and send documents">
              <Button
                type="one"
                className="analyse-document"
                data-test="quotation-rejected-send-button"
                onClick={this.showMenu}>
                Send document
                <i
                  className={`ic-dropdown ${
                    this.state.showMenu ? "dropdown-open" : ""
                  }`}>
                  <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="documentrecipientlist-role-icon"
                  />
                </i>
              </Button>
            </Tooltip>
            {this.state.showMenu && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <Tooltip
                    placement="left"
                    overlay="Recipients get an email with document link and a request to <b>review and collaborate.</b>"
                    imgUrl={SEND_TO_SOMEONE_PNG}
                    imgAltTxt="send-for-acceptance">
                    <li>
                      <div
                        data-test="cta-send-to-someone-button"
                        className="send-list-item"
                        role="button"
                        tabIndex="0"
                        onClick={() => this._handleOptionList("reviewer")}
                        onKeyPress={() => this._handleOptionList("reviewer")}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "paper-plane"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Send to someone
                          </div>
                          <div className="btn-send-desc">
                            {`Send document to recipient's email and give them
                              view or edit access.`}
                          </div>
                        </div>
                      </div>
                    </li>
                  </Tooltip>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="btn-export-wrapper" ref={this.createExportRef}>
            <Tooltip placement="bottom" overlay="Share link or publish to web">
              <Button
                className="analyse-document"
                type="one"
                data-test="quotation-draft-btns-share"
                onClick={this.showShareOptions}>
                <FontAwesomeIcon
                  icon={["far", "share-alt"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showShareOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <Tooltip
                    placement="left"
                    overlay="Any <b>changes</b> made on the <b>document gets updated</b> on the magic link."
                    imgUrl={MAGICLINK_PNG}
                    imgAltTxt="send-for-acceptance">
                    <li>
                      <div
                        data-test="share-magic-link"
                        className="send-list-item"
                        role="button"
                        tabIndex="0">
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "globe"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Share a magic link
                          </div>
                          <div className="btn-send-desc">
                            Copy shareable link with a live view of document
                          </div>
                        </div>
                        <div className="btn-share-toggle revv-perma-toggle">
                          <Input
                            data-test="input-revv-inp-checkbox-or-radio"
                            className=" docsharingpopup-sharingform-col"
                            isSwitch
                            type="checkbox"
                            onChange={() =>
                              this.props.checkToggleValue("copyLink")
                            }
                            value=""
                            checked={this.props.activeShare}
                          />
                        </div>
                      </div>
                      {this.props.activeShare &&
                        this.props.docPermaLink !== "" && (
                          <div className="permalink-wrapper">
                            <Input
                              ref={this.textInputRef}
                              type="text"
                              id="permaLinkCopy"
                              className="revv-inp"
                              value={this.props.docPermaLink}
                              placeholder="Generating link..."
                              disabled
                            />

                            <div className="copy-btn">
                              <Button
                                className="revv-btn-secondary"
                                onClick={() =>
                                  this._handleCopyLink(this.props.docPermaLink)
                                }
                                data-test="quotation-draft-btns-copy">
                                Copy
                              </Button>
                            </div>
                          </div>
                        )}
                    </li>
                  </Tooltip>
                  {!this.props.isPdfDocument && (
                    <Tooltip
                      placement="left"
                      overlay="The <b>snap link</b> will be a <b>timestamped</b> static <b>version</b> of the document."
                      imgUrl={SNAPLINK_PNG}
                      imgAltTxt="send-for-acceptance">
                      <li>
                        <div
                          data-test="share-snap-link"
                          className="send-list-item"
                          role="button"
                          tabIndex="0">
                          <div className="btn-send-icon">
                            <FontAwesomeIcon
                              icon={["far", "link"]}
                              className="documentrecipientlist-role-icon"
                            />
                          </div>
                          <div>
                            <div className="btn-send-heading">
                              Publish a snap link to web
                              <span className="save-doc-temp-new-tag">New</span>
                            </div>
                            <div className="btn-send-desc">
                              Get a search engine friendly link of your document
                              and share it anywhere.
                            </div>
                          </div>
                          <div className="btn-share-toggle revv-perma-toggle">
                            <Input
                              data-test="input-revv-inp-checkbox-or-radio"
                              className=" docsharingpopup-sharingform-col"
                              isSwitch
                              type="checkbox"
                              onChange={() =>
                                this.props.checkToggleValue("copySnapLink")
                              }
                              value=""
                              checked={this.props.activeSnapShare}
                            />
                          </div>
                        </div>
                        {this.props.activeSnapShare &&
                          this.props.docSnapLink !== "" && (
                            <div>
                              <div className="permalink-wrapper">
                                <Input
                                  ref={this.textInputRef}
                                  type="text"
                                  id="permaLinkCopy"
                                  className="revv-inp"
                                  value={this.props.docSnapLink}
                                  placeholder="Generating link..."
                                  disabled
                                />

                                <div className="copy-btn">
                                  <Button
                                    className="revv-btn-secondary"
                                    onClick={() =>
                                      this._handleCopyLink(
                                        this.props.docSnapLink,
                                      )
                                    }
                                    data-test="quotation-draft-btns-copy">
                                    Copy
                                  </Button>
                                </div>
                              </div>
                              <div className="snaplink-generated-info">
                                <span>
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={["far", "info-circle"]}
                                  />
                                </span>
                                <span>
                                  {" "}
                                  {ReactHtmlParser(
                                    snaplinkGeneratedInfo(
                                      this.props.docSnapLinkCreatedAt,
                                    ),
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                      </li>
                    </Tooltip>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="btn-export-wrapper" ref={this.createShareRef}>
            <Tooltip placement="bottom" overlay="More">
              <Button
                className="analyse-document"
                data-test="quotation-draft-btns-more"
                type="one"
                onClick={this.showMoreOptions}>
                <FontAwesomeIcon
                  icon={["far", "ellipsis-v"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showMoreOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        DOCUMENT ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="download-doc-stage-btn"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("download")}
                      onKeyPress={() => this._handleOptionList("download")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "download"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Download document
                        </div>
                        <div className="btn-send-desc">
                          Download a PDF of this document
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-metalense-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("metalense")}
                      onKeyPress={() => this._handleOptionList("metalense")}>
                      <div className="btn-send-icon">
                        {/* <FontAwesomeIcon
                          icon={["far", "microscope"]}
                          className="documentrecipientlist-role-icon"
                        /> */}
                        <QuickReviewIcon />
                      </div>
                      <div>
                        <div className="btn-send-heading">Enable Metalens</div>
                        <div className="btn-send-desc">
                          Use A.I to analyze document for critical data
                        </div>
                      </div>
                    </div>
                  </li>
                  {!this.props.isPdfDocument && (
                    <li>
                      <div
                        className="send-list-item"
                        role="button"
                        data-test="cta-preview-document-button"
                        tabIndex="0"
                        onClick={this._toggleDocPreviewPopUp}
                        onKeyPress={() => {}}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "eye"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            {" "}
                            Preview document
                          </div>
                          <div className="btn-send-desc">
                            See a PDF preview of document
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        REUSE THIS DOCUMENT
                      </div>
                    </div>
                  </li>
                  {!this.props.isPdfDocument &&
                    CURRENT_USER &&
                    CURRENT_USER.roles &&
                    CURRENT_USER.roles.length > 0 &&
                    CURRENT_USER.roles[0].name === "Admin" && (
                      <DocToTemplateBtn
                        togglePopup={this.toggleDocToTemplatePopup}
                      />
                    )}
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-clone-document-button"
                      tabIndex="0"
                      onClick={this._cloneDocument}
                      onKeyPress={() => {}}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "clone"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading"> Clone document</div>
                        <div className="btn-send-desc">
                          Create a copy and reuse the document as needed
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        OTHER ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-invite-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("invite")}
                      onKeyPress={() => this._handleOptionList("invite")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "user-plus"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Invite a teammate to Revv
                        </div>
                        <div className="btn-send-desc">
                          Invite colleagues to join you on Revv and work
                          together
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-refer-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("reffer")}
                      onKeyPress={() => this._handleOptionList("reffer")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "gift"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Refer someone and get benefits
                        </div>
                        <div className="btn-send-desc">
                          Refer businesses, consultants and peers to get Amazon
                          gift cards
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* <SendForReview {...this.props} /> */}

        {/* <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp(
              "showAddRecipientsPopup",
              true,
              "forReviewer",
            )
          }
          id={"Send for review".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Share
        </Button> */}
        {/* <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp("showConfirmMoveToDraftPopup", true)
          }
          id={"EditBtnWithRbac".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Edit document
        </Button> */}
        {/* <ExportDocumentBtn docStatus={this.props.docStatus} /> */}
        {/* {this._acceptanceStatusBand()} */}
        {this.state.showDocPreview && (
          <PreviewDocument
            togglePopUp={this._toggleDocPreviewPopUp}
            html={QuotationRejectedBtns.documentHTMLData}
          />
        )}
      </Fragment>
    );
  }
}
const mapDispatchToProps = {
  fetchDocRecipientListAction,
  updateToolPaneData,
};

export default connect(
  null,
  mapDispatchToProps,
)(QuotationRejectedBtns);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationRejectedBtns.js